import { render, staticRenderFns } from "./Demography.vue?vue&type=template&id=78ce3fd8&scoped=true&"
var script = {}
import style0 from "./Demography.vue?vue&type=style&index=0&id=78ce3fd8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78ce3fd8",
  null
  
)

export default component.exports